import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import Resources from './components/Resources';
import Team from './components/Team';
import Profile from './components/Profile';
import Navbar from './components/Navbar';
import './App.css';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);

  useEffect(() => {
    // Mock: verificar si hay un usuario en localStorage
    const savedUser = localStorage.getItem('innovaUser');
    if (savedUser) {
      setUser(JSON.parse(savedUser));
      setIsAuthenticated(true);
    }
  }, []);

  const handleLogin = (userData) => {
    setUser(userData);
    setIsAuthenticated(true);
    localStorage.setItem('innovaUser', JSON.stringify(userData));
  };

  const handleLogout = () => {
    setUser(null);
    setIsAuthenticated(false);
    localStorage.removeItem('innovaUser');
  };

  return (
    <Router>
      <div className="App">
        {isAuthenticated && <Navbar user={user} onLogout={handleLogout} />}
        <Routes>
          <Route 
            path="/login" 
            element={
              isAuthenticated ? 
              <Navigate to="/dashboard" replace /> : 
              <Login onLogin={handleLogin} />
            } 
          />
          <Route 
            path="/dashboard" 
            element={
              isAuthenticated ? 
              <Dashboard user={user} /> : 
              <Navigate to="/login" replace />
            } 
          />
          <Route 
            path="/resources" 
            element={
              isAuthenticated ? 
              <Resources user={user} /> : 
              <Navigate to="/login" replace />
            } 
          />
          <Route 
            path="/resources/:resourceId" 
            element={
              isAuthenticated ? 
              <Resources user={user} /> : 
              <Navigate to="/login" replace />
            } 
          />
          <Route 
            path="/equipo" 
            element={
              isAuthenticated ? 
              <Team user={user} /> : 
              <Navigate to="/login" replace />
            } 
          />
          <Route 
            path="/perfil" 
            element={
              isAuthenticated ? 
              <Profile user={user} /> : 
              <Navigate to="/login" replace />
            } 
          />
          <Route 
            path="/" 
            element={
              isAuthenticated ? 
              <Navigate to="/dashboard" replace /> : 
              <Navigate to="/login" replace />
            } 
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
